import { render, staticRenderFns } from "./ContentCreator.vue?vue&type=template&id=00978cb2&scoped=true&"
import script from "./ContentCreator.vue?vue&type=script&lang=ts&"
export * from "./ContentCreator.vue?vue&type=script&lang=ts&"
import style0 from "./ContentCreator.vue?vue&type=style&index=0&id=00978cb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00978cb2",
  null
  
)

export default component.exports